<template>
  <header
    class="contain mb-0 pt-4 sticky top-0 z-50 bg--gradient-down overflow-visible"
  >
    <h1
      class="title-2 whitespace-normal text-6xl sm:text-7xl md:text-8xl text-left font-bold tracking-tight overflow-visible leading-none"
    >
      <slot name="default" />
    </h1>
    <h2
      class="title-2 mb-10 whitespace-normal text-2xl sm:text-3xl text-left font-bold overflow-visible leading-none bg-transparent"
    >
      <slot name="sub-heading" />
    </h2>
  </header>
</template>

<script>
export default {
  name: 'SHeader'
}
</script>
